export default __webpack_public_path__ + "static/media/split-logo.6c615269.png";